module.exports = __webpack_public_path__ + "static/media/credit_card.c197ece5.svg";